


























































































import Vue from "vue";

import { ServiceProductOrderApi } from "@/api";
import stateMixin from "@/mixins/state";
import { formatCurrency } from "@/util/currency";
import { toLocalDateTimeString } from "@/util/date";

export default Vue.extend({
  data() {
    return {
      data: [],
      headers: [
        { text: "Aantal", value: "amount", width: "100", sortable: false },
        { text: "ID", value: "serviceProductId" },
        {
          text: "Artikelcode",
          align: "left",
          sortable: false,
          value: "serviceProductArticleCode",
          width: "150"
        },
        { text: "Naam", value: "serviceProductName" },
        { text: "Prijs", value: "price", width: "100", align: "right" },
        { text: "Totaal", value: "rowTotalPrice", width: "100", align: "right" }
      ],
      options: {
        page: 1,
        itemsPerPage: 20
      }
    };
  },
  name: "ServiceProductOrderDetail",
  mixins: [stateMixin],
  mounted() {
    if (this.$route.params.id) {
      this.fetch(Number(this.$route.params.id));
    }
  },
  methods: {
    toLocalDateTimeString,
    formatCurrency,
    fetch: async function(id) {
      this.setState(this.states.LOADING);
      const api = new ServiceProductOrderApi();
      try {
        const {
          data
        } = await api.serviceProductOrderGetServiceProductOrderById(id);
        this.data = data;
        this.setState(this.states.INITIAL);
      } catch {
        this.setState(this.states.ERROR);
      }
    }
  }
});
